import { getMySummaryFeedbackApi } from '../api';

export const getMySummaryFeedback = async ({ employeeId, limit = 3, offset = 0 }) => {
  try {
    const res = await getMySummaryFeedbackApi({ employeeId, limit, offset });
    return res?.entity;
  } catch (error) {
    console.error('Error fetching my summary for feedback : ', error);
  }
};
